import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Section5 = () => {
  const { t, i18n } = useTranslation();

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="container" style={{ minHeight: '85vh' }}>
      <div className="row mt-5">
        <div className="col-md-6 col-12">
          <div className="mt-5">
            <h3 className="title mt-5 mb-5">{t('whyChooseTSG')}</h3>
          </div>
          <div className="mt-5" style={{ paddingRight: '50px' }}>
            <h4 style={{ maxWidth: '90%' }} className="section-title mt-3">
              {t('zeroEmissionTransport')}
            </h4>
            <div style={{ border: '1px solid black' }} />
            <div className="mt-4" style={{ maxWidth: '450px' }}>
              <p className="text mt-1">{t('innovativeAlternative')}</p>
            </div>
          </div>
          <div className="mt-5" style={{ paddingRight: '50px' }}>
            <h4 style={{ maxWidth: '90%' }} className="section-title mt-3">
              {t('mobileShowcase')}
            </h4>
            <div style={{ border: '1px solid black' }} />
            <div className="mt-4" style={{ maxWidth: '450px' }}>
              <p className="text mt-1">{t('brandingOpportunity')}</p>
            </div>
          </div>
          <div className="mt-5 mb-5" style={{ paddingRight: '50px' }}>
            <h4 style={{ maxWidth: '90%' }} className="section-title mt-3">
              {t('carbonCredits')}
            </h4>
            <div style={{ border: '1px solid black' }} />
            <div className="mt-4" style={{ maxWidth: '450px' }}>
              <p className="text mt-1">{t('carbonCreditOpportunity')}</p>
            </div>
          </div>
        </div>
        <div className="col-6 px-5 py-5">
          {' '}
          <img src="./img/map-why.png" height={580} alt="map-why" />
        </div>
      </div>
    </div>
  );
};

export default Section5;
